module.exports = __webpack_public_path__ + "media/plans/free-753121e7.png";